<template>
  <Container type="card-full">
    <div class="search">
      <div class="search_box">
        <div class="searchItem">
          <div class="label">项目编号</div>
          <div class="field">
            <el-input v-model.trim="query.projectcode" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="label">项目名称</div>
          <div class="field">
            <el-input v-model.trim="query.projectname" clearable ></el-input>
          </div>
        </div>
        <div class="searchItem">
          <div class="search_btn">
            <el-button @click="search">查询</el-button>
          </div>
        </div>
      </div>
    </div>
    <vggrid :list="list" tableheight="600" flexname="" :cols="cols"
            :showfooter="false" :showPage="true" :resizable="true"
            :total="query.total" @cellClick="cellClick"  @cellDblClick="viewProject" @pagechange="pagechange"
            :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'projectPbrIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        btnLoading: false,
        cols: [
          { type: 'index',fieldtype: 'I', title: '行号',calculExpr:'', width: 80 },
          { field: 'projectcode', fieldtype: 'C', title: '项目编号',calculExpr:'',addNewRowFlg: false},
          { field: 'projectname', fieldtype: 'C', title: '项目名称',calculExpr:'',addNewRowFlg: false},
          // { field: 'projectdesc', fieldtype: 'C', title: '采购内容',calculExpr:'',addNewRowFlg: false},
          { field: 'prsbjbegtime', fieldtype: 'T', title: '报价开始时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']},
          { field: 'prsbjendtime', fieldtype: 'T', title: '报价截止时间',calculExpr:'',addNewRowFlg: false,formatter: ['toDateString', '']}
        ],
        project: {},
        query: {
          cosid: this.$store.getters.loginUser.cosid,
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('PBRCENTER', () => this.pbrCenter())
      this.$on('PBRLIST', () => this.pbrList())
      this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.init()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      async viewProject(row) {
        this.project = row.row
        this.$router.push({name: 'pbrCenterForm', params: {projectid: this.project.projectid, type: 1}})
      },
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.project = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async init() {
        this.query = {
          cosid: this.$store.getters.loginUser.cosid,
          comid: this.$store.getters.loginUser.usercomid,
          total: 0,
          limit: 20,
          offset: 0}
        this.list = []
        this.btnLoading = false
        this.project = {}
      },
      async pbrCenter () {
        if (!this.project.projectid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        this.$router.push({name: 'pbrCenterForm', params: {projectid: this.project.projectid, type: 1}})
      },
      async pbrList () {
        if (!this.project.projectid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        this.$router.push({name: 'pbrListForm', params: {form: this.project, type: 1}})
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async cellClick (row) {
        this.project = row.row
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      search () {
        this.query.offset = 0
        this.getPageList()
      },
      async getPageList () {
        console.log(this.query)
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/xmgl/project/getProjectPbrPageList',
          params: this.query
        })
        console.log(res)
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
